import PronunciationAssessmentView from "@features/tools/view/pronunciation-assessment-view/pronunciation-assessment-view";

const PronunciationAssessment = () => {
  return <PronunciationAssessmentView />;
};

export default PronunciationAssessment;
